<template>
  <div class="jobNavigation">
    <div class="searchBox">
      <div class="search">
        <input
          type="text"
          v-model.trim="value"
          placeholder="请输入工作流名称"
        />
        <span @click="handleSearch">
          <svg-icon icon-class="search" style="cursor: pointer" />
        </span>
      </div>
    </div>
    <div class="jobBox">
      <div
        class="jobItem"
        v-for="(item, index) in data2"
        :key="index"
        @click="handleJump(item)"
      >
        <span></span>
        <div class="right">
          <div class="title">{{ item.code }}</div>
          <!-- <div class="text">{{item.value}}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getAll();
  },
  data() {
    return {
      value: "",
      data2: [],
      data: [
        {
          title: "出差费用申请",
          value: "用于出差、共用外出等活动的相关费用",
          path: "/travelBx",
        },
        {
          title: "出差费用报销",
          value: "用于出差、共用外出等活动的相关费用",
          path: "/travelBx",
        },
        {
          title: "零星费用报销",
          value: "用于出差、共用外出等活动的相关费用",
          path: "/travelBx",
        },
        {
          title: "市内出差报销",
          value: "用于出差、共用外出等活动的相关费用",
          path: "/travelBx",
        },
        {
          title: "差旅超标申请",
          value: "用于出差、共用外出等活动的相关费用",
          path: "/travelBx",
        },
      ],
    };
  },
  methods: {
    getAll() {
      this.$api.post("/payment/center/hoau/dict/getAll", {}).then((res) => {
        if (res.repCode == "0000") {
          this.data = res.repData.HOAU_WORKFLOW;
          this.data2 = res.repData.HOAU_WORKFLOW;
          // this.data2 = [
          //   ...this.data2,
          //   {
          //     code: "业务招待费报销",
          //     name: "5",
          //   },
          //   {
          //     code: "通讯费报销",
          //     name: "6",
          //   },
          //   {
          //     code: "用车费报销",
          //     name: "7",
          //   },
          //   {
          //     code: "房费车费报销",
          //     name: "8",
          //   },
          //   {
          //     code: "日常福利报销",
          //     name: "9",
          //   },
          // ];
          // this.data = this.data2
        }
      });
    },
    handleSearch() {
      this.data2 = this.data.filter(
        (item) => item.code.indexOf(this.value) != -1
      );
    },
    handleJump(item) {
      let path = "";
      if (item.name == "0") {
        path = "/travelSq";
      }
      if (item.name == "1") {
        path = "/travelBx";
      }
      if (item.name == "2") {
        path = "/cityBx";
      }
      if (item.name == "3") {
        path = "/pettyExpenseBx";
      }
      if (item.name == "4") {
        path = "/excessiveApplication";
      }
      if (item.name == "5") {
        path = "/bx5";
      }
      if (item.name == "6") {
        path = "/bx6";
      }
      if (item.name == "7") {
        path = "/bx7";
      }
      if (item.name == "8") {
        path = "/bx8";
      }
      if (item.name == "9") {
        path = "/bx9";
      }
      if (item.name == "10") {
        path = "/bx10";
      }
      if (item.name == "11") {
        path = "/bx11";
      }
      if (item.name == "12") {
        path = "/bx12";
      }
      if (item.name == "13") {
        path = "/bx13";
      }
      this.$router.push({
        path,
        query: {
          workflowName: item.code,
          workflow: item.name,
          type: "add",
        },
        name:path.split("/")[1],
        params:{
          fristEnter:true
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// .jobNavigation {
//   height: 100%;
//   // font-size: 12px;
//   .searchBox {
//     padding: 10px 18px;
//     background: #fff;
//     .search {
//       display: flex;
//       align-items: center;
//       border: 1px solid #ccc;
//       border-radius: 4px;
//       padding: 10px;
//       input {
//         flex: 1;
//         outline: none;
//         border: none;
//         background:rgba($color: #000000, $alpha: .0);
//       }
//     }
//   }
//   .jobBox{
//     padding:0 18px;
//   }
//   .jobItem{
//     display: flex;
//     align-items: center;
//     height: 70px;
//     background: #fff;
//     border-radius: 6px;
//     box-shadow: 0px 3px 10px 0 #ccc;
//     margin-top: 18px;
//     >span{
//       width: 4px;
//       height: 30px;
//       background: rgb(58, 117, 197);
//       margin-right: 20px;
//     }
//     .title{
//       font-size: 14px;
//     }
//     .text{
//       color:rgb(152, 152, 152);
//       margin-top: 4px;
//     }
//   }
// }
</style>